/*
 * @Author: LiuXin
 * @Date: 2021-11-11 17:42:06
 * @LastEditors: LiuXin
 * @LastEditTime: 2022-01-11 14:41:58
 */

// 腾讯广告
export const txggDict = {
  // 联网方式
  networkType: key => {
    const dict = {
      WIFI: '无线网络',
      NET_2G: '2G网络',
      NET_3G: '3G网络',
      NET_4G: '4G网络',
    };
    return dict[key];
  },
  // 联网方式
  siteSet: key => {
    const dict = [
      { value: 'SITE_SET_MOBILE_UNION', label: '优量汇', channel: 'GDT' },
      { value: 'SITE_SET_WECHAT', label: '微信公众号与小程序', channel: 'GDT' },
      { value: 'SITE_SET_MOBILE_MYAPP', label: '应用宝', channel: 'GDT' },
      { value: 'SITE_SET_MOBILE_INNER', label: 'QQ、腾讯看点、腾讯音乐', channel: 'GDT' },
      { value: 'SITE_SET_TENCENT_NEWS', label: '腾讯新闻', channel: 'GDT' },
      { value: 'SITE_SET_TENCENT_VIDEO', label: '腾讯视频', channel: 'GDT' },
      { value: 'SITE_SET_MOBILE_YYB', label: '应用宝', channel: 'GDT' },
      { value: 'SITE_SET_PCQQ', label: 'PC QQ、QQ 空间、腾讯音乐', channel: 'GDT' },
      { value: 'SITE_SET_KANDIAN', label: '腾讯看点', channel: 'GDT' },
      { value: 'SITE_SET_QQ_MUSIC_GAME', label: 'QQ、腾讯音乐及游戏', channel: 'GDT' },
      { value: 'SITE_SET_MOMENTS', label: '微信朋友圈', channel: 'GDT' },
      { value: 'SITE_SET_MINI_GAME_WECHAT', label: '微信小游戏', channel: 'GDT' },
      { value: 'SITE_SET_MINI_GAME_QQ', label: 'QQ 小游戏', channel: 'GDT' },
      { value: 'SITE_SET_MOBILE_GAME', label: 'App 游戏', channel: 'GDT' },
      { value: 'SITE_SET_QQSHOPPING', label: 'QQ 购物', channel: 'GDT' },
    ];
    return dict.find(item => item.value == key)?.[label];
  },
  // 计划类型
  campaignType: key => {
    const dict = localStorage.planCodesOptionsGDT ? JSON.parse(localStorage.planCodesOptionsGDT) : [];
    const obj = dict.find(item => item.value == key) || {};
    return obj.label;
  },
  // 推广目标
  promotedObjectType: key => {
    const dict = localStorage.targetTypeCodesOptionsGDT ? JSON.parse(localStorage.targetTypeCodesOptionsGDT) : [];
    const obj = dict.find(item => item.value == key) || {};
    return obj.label;
  },
  // 版位信息
  siteSet: key => {
    const dict = localStorage.promoteCodesOptionsGDT ? JSON.parse(localStorage.promoteCodesOptionsGDT) : [];
    const obj = dict.find(item => item.value == key) || {};
    return obj.label;
  },
  // 广告状态
  adStatus: key => {
    const dict = localStorage.advertiseStatusCodesOptionsGDT ? JSON.parse(localStorage.advertiseStatusCodesOptionsGDT) : [];
    const obj = dict.find(item => item.value == key) || {};
    return obj.label;
  },
  // 投放方式
  speedMode: key => {
    const dict = { FAST: '加速投放', STANDARD: '标准投放' };
    return dict[key];
  },
  // 创意状态
  systemStatusDict: key => {
    const dict = {
      NORMAL: '有效',
      PENDING: '待审核',
      DENIED: '审核不通过',
      PARTIALLY_PENDING: '部分审核中',
      PARTIALLY_NORMAL: '部分有效',
      PREPARE: '准备中(当投放视频广告时,该状态代表视频转码中)',
      DELETED: '已删除',
      INVALID: '异常(当投放视频广告时,该状态代表视频转码失败)',
    };
    return dict[key];
  },
  // 优化目标
  optimizationGoal: key => {
    const dict = { NONE: 'none', BRAND_CONVERSION: '指定页面曝光', FOLLOW: '关注', CLICK: '点击', IMPRESSION: '曝光', APP_DOWNLOAD: '下载', APP_ACTIVATE: '激活', APP_REGISTER: '注册', ONE_DAY_RETENTION: '次日留存', APP_PURCHASE: '付费次数', ECOMMERCE_ORDER: '下单', ECOMMERCE_CHECKOUT: 'H5 付费次数（待废弃）', LEADS: '表单预约（微信流量，待废弃）', ECOMMERCE_CART: '加入购物车', PROMOTION_CLICK_KEY_PAGE: 'H5 注册（待废弃）', VIEW_COMMODITY_PAGE: '商品详情页浏览', ONLINE_CONSULTATION: '在线咨询', TELEPHONE_CONSULTATION: '电话拨打', PAGE_RESERVATION: '表单预约', DELIVERY: '发货', MESSAGE_AFTER_FOLLOW: '公众号内发消息', CLICK_MENU_AFTER_FOLLOW: '公众号内点击菜单栏', PAGE_EFFECTIVE_ONLINE_CONSULT: '有效在线咨询(已废弃)', PAGE_EFFECTIVE_PHONE_CALL: '有效电话拨打(已废弃)', CONFIRM_EFFECTIVE_LEADS_CONSULT: '有效在线咨询（待废弃）', CONFIRM_EFFECTIVE_LEADS_PHONE: '有效电话拨打（待废弃）', LEADS_COLLECT: '综合线索收集', FIRST_PURCHASE: '首次付费', APPLY: '进件', PRE_CREDIT: '预授信', CREDIT: '授信', WITHDRAW_DEPOSITS: '提现', PROMOTION_VIEW_KEY_PAGE: '关键页面访问', MOBILE_APP_CREATE_ROLE: '小游戏创角', CANVAS_CLICK: '跳转按钮点击', PROMOTION_CLAIM_OFFER: '领券', ECOMMERCE_ADD_TO_WISHLIST: '商品收藏', CONFIRM_EFFECTIVE_LEADS_RESERVATION: '有效表单预约（待废弃）', PAGE_RECEIPT: '签收', PAGE_SCAN_CODE: '加企业微信客服', SELECT_COURSE: '选课', CONFIRM_POTENTIAL_CUSTOMER_PHONE: '电话潜在客户', MOBILE_APP_AD_INCOME: '广告变现', MOBILE_APP_ACCREDIT: '小游戏授权', PURCHASE_MEMBER_CARD: '首次会员购买', PAGE_CONFIRM_EFFECTIVE_LEADS: '有效综合线索', ADD_DESKTOP: '快应用加桌面', RESERVATION: '微信流量预约行为', FIRST_ECOMMERCE_ORDER: '首次下单', FIRST_TWENTY_FOUR_HOUR_ECOMMERCE_ORDER: '24 小时下单', LIKE: '点赞', EXTERNAL_LINK_CLICK: '外链点击', BUY_COUPONS: '购券', LEAVE_INFORMATION: '留资', CORE_ACTION: '关键行为', ONE_DAY_RETENTION_RATIO: '次留率', PROMOTION_READ_ARTICLE: '阅读文章' };
    return dict[key];
  },
  // 出价类型
  bidType: key => {
    const dict = { 1: 'CPM', 2: 'CPC', 6: 'OCPC', 10: 'OCPM', 20: 'eCPC' };
    return dict[key];
  },
  // 出价策略
  strategy: key => {
    const dict = { AVERAGE_COST: '稳定拿量', TARGET_COST: '优先拿量', PRIORITY_LOW_COST: '优先低成本' };
    return dict[key];
  },
  // 深度转化类型
  deepConversionType: key => {
    const dict = { WORTH: '优化 ROI', BEHAVIOR: '优化转化行为' };
    return dict[key];
  },
};

// 巨量引擎
export const jlyqDict = {
  // 创意状态
  creativityStatus: key => {
    const dict = {
      CREATIVE_STATUS_DELIVERY_OK: '投放中',
      CREATIVE_STATUS_NOT_START: '未到达投放时间',
      CREATIVE_STATUS_NO_SCHEDULE: '不在投放时段',
      CREATIVE_STATUS_DISABLE: '创意暂停',
      CREATIVE_STATUS_CAMPAIGN_DISABLE: '已被广告组暂停',
      CREATIVE_STATUS_CAMPAIGN_EXCEED: '广告组超出预算',
      CREATIVE_STATUS_AUDIT: '新建审核中',
      CREATIVE_STATUS_REAUDIT: '修改审核中',
      CREATIVE_STATUS_DELETE: '已删除',
      CREATIVE_STATUS_DONE: '已完成(投放达到结束时间)',
      CREATIVE_STATUS_AD_DISABLE: '广告计划暂停',
      CREATIVE_STATUS_AUDIT_DENY: '审核不通过',
      CREATIVE_STATUS_BALANCE_EXCEED: '账户余额不足',
      CREATIVE_STATUS_BUDGET_EXCEED: '超出预算',
      CREATIVE_STATUS_DATA_ERROR: '数据错误(数据错误时返回,极少出现)',
      CREATIVE_STATUS_PRE_ONLINE: '预上线',
      CREATIVE_STATUS_AD_AUDIT: '广告计划新建审核中',
      CREATIVE_STATUS_AD_REAUDIT: '广告计划修改审核中',
      CREATIVE_STATUS_AD_AUDIT_DENY: '广告计划审核不通过',
      CREATIVE_STATUS_ALL: '所有包含已删除',
      CREATIVE_STATUS_NOT_DELETE: '所有不包含已删除(状态过滤默认值)',
      CREATIVE_STATUS_ADVERTISER_BUDGET_EXCEED: '超出账户日预算',
    };
    return dict[key];
  },
  // 推广目的类型
  landingType: key => {
    const dict = {
      LINK: '销售线索收集',
      APP: '应用推广',
      QUICK_APP: '快应用推广',
      DPA: '商品目录推广',
      G0ODS: '商品推广(鲁班)',
      STORE: '门店推广',
      AWEME: '抖音号推广',
      SHOP: '电商店铺推广',
      LIVE: '直播间推广',
      ARTICAL: '头条文章推广。目前API暂不支持该推广目的的设定,可在平台侧选择该推广目的类型',
    };
    return dict[key];
  },
  // 广告组状态
  campaignStatus: key => {
    const k = key.split(':')?.[0];
    const dict = {
      CAMPAIGN_STATUS_ENABLE: '启用',
      CAMPAIGN_STATUS_DISABLE: '暂停',
      CAMPAIGN_STATUS_DELETE: '删除',
      CAMPAIGN_STATUS_ALL: '所有包含已删除',
      CAMPAIGN_STATUS_NOT_DELETE: '所有不包含已删除(状态过滤默认值)',
      CAMPAIGN_STATUS_ADVERTISER_BUDGET_EXCEED: '超出广告主日预算',
    };
    return dict[k];
  },
  // 广告组类型
  campaignType: key => {
    const dict = {
      FEED: '信息流',
      SEARCH: '搜索广告',
    };
    return dict[key];
  },
  // 广告组预算
  budgetType: key => {
    const flag = key.split(':')[1];
    if (flag == 'BUDGET_MODE_INFINITE') {
      return '不限';
    } else {
      return key.split(':')[0] ? key.split(':')[0] + ' 元/天' : '-';
    }
  },
  // 广告组预算类型
  budgetMode: key => {
    const dict = {
      // BUDGET_MODE_INFINITE: '不限',
      BUDGET_MODE_DAY: '按日预算',
      BUDGET_MODE_TOTAL: '按总预算',
    };
    return dict[key];
  },
  // 广告组营销链路
  marketingPurpose: key => {
    const dict = {
      CONVERSION: '行动转化',
      INTENTION: '用户意向',
      ACKNOWLEDGE: '品牌认知',
    };
    return dict[key];
  },
  // 计划首选位置
  inventoryType: key => {
    const adInventoryType = localStorage.adInventoryTypeCodesOptionsTT && JSON.parse(localStorage.adInventoryTypeCodesOptionsTT);
    let dict = {};
    adInventoryType?.forEach(item => {
      dict[item.value] = item.label;
    });
    dict =
      adInventoryType.length > 0
        ? dict
        : {
            INVENTORY_AUTOMOBILE: '懂车帝',
            INVENTORY_AWEME_FEED: '抖音信息',
            INVENTORY_AWEME_SEARCH: '搜索广告——抖音位',
            INVENTORY_BEAUTY: '轻颜相机',
            INVENTORY_FACE_U: 'faceu',
            INVENTORY_FEED: '头条信息流',
            INVENTORY_HOTSOON_FEED: '火山信息流',
            INVENTORY_PIPIXIA: '皮皮虾',
            INVENTORY_SEARCH: '搜索广告——头条位',
            INVENTORY_STUDY: '好好学习',
            INVENTORY_TEXT_LINK: '头条文章详情页',
            INVENTORY_TOMATO_NOVEL: '番茄小说',
            INVENTORY_UNION_SLOT: '穿山甲',
            INVENTORY_UNION_SPLASH_SLOT: '穿山甲开屏广告',
            INVENTORY_UNIVERSAL: '通投智选',
            INVENTORY_VIDEO_FEED: '西瓜信息流',
            UNION_BOUTIQUE_GAME: 'ohayoo精品游戏',
          };
    return dict[key];
  },
  // 计划过滤已转化用户类型
  hideIfConverted: key => {
    const dict = {
      NO_EXCLUDE: '不过滤',
      AD: '广告计划',
      CAMPAIGN: '广告组',
      ADVERTISER: ' 广告账户',
      APP: 'APP',
      CUSTOMER: '公司账户',
    };
    return dict[key];
  },
  // 计划下载方式
  downloadType: key => {
    const dict = {
      DOWNLOAD_URL: '下载链接',
      QUICK_APP_URL: '快应用+下载链接',
      EXTERNAL_URL: '落地页链接',
    };
    return dict[key];
  },
  // 计划状态
  adStatus: key => {
    const dict = {
      AD_STATUS_DELIVERY_OK: '投放中',
      AD_STATUS_DISABLE: '计划暂停',
      AD_STATUS_AUDIT: '新建审核中',
      AD_STATUS_REAUDIT: '修改审核中.',
      AD_STATUS_DONE: '已完成(投放达到结束时间)',
      AD_STATUS_CREATE: '计划新建:',
      AD_STATUS_AUDIT_DENY: '审核不通过',
      AD_STATUS_BALANCE_EXCEED: '账户余额不足',
      AD_STATUS_BUDGET_EXCEED: '超出预算',
      AD_STATUS_NOT_START: '未到达投放时间',
      AD_STATUS_NO_SCHEDULE: '不在投放时段',
      AD_STATUS_CAMPAIGNDISABLE: '已被广告组暂停',
      AD_STATUS_CAMPAIGN_EXCEED: '厂告组超出预算',
      AD_STATUS_DELETE: '已删除',
      AD_STATUS_ALL: '所有包含已删除',
      AD_STATUS_NOT_DELETE: '所有不包含已删除(状态过滤默认值)',
      AD_STATUS_ADVERTISER_BUDGET_EXCEED: '超出广告主日预算',
      AD_STATUS_LIVE_CANNOT_LANUCH: '关联直摘间不可投放,该枚举值仅用作广告计划投放状态展示,不可在状态过相时使用',
      AD_STATUS_CAMPAIGN_PRE_OFFLINE_BUDGET: '广告组接近预算,该枚举值仅用作广告计划投放状态展示，可在状态过滤时使用',
      AD_STATUS_PRE_OFFLINE_BUDGET: '广告接近预算,该枚举值仅用作广告计划投放状态展示，可在状态过滤时使用',
      AD_STATUS_PRE_ONLINE: '预上线该枚举值仅用作广告计划投放状态展示，可在状态过滤时使用',
      AD_STATUS_DSP_AD_DISABLE: '已被广告计划暂停,该枚举值仅用作广告计划投放状态展示，不可在状态过滤时使用',
      AD_STATUS_AUDIT_STATUS_ERROR: '异常，请联系审核人员该枚举值仅用作广告计划投放状态展示，不可在状态过滤时使用',
      AD_STATUS_DRAFT: '草稿,该枚举值仅用作广告计划投放状态展示，不可在状态过滤时使用',
      AD_STATUS_ADVERTISER_PRE_OFFLINE_BUDGET: '账户接近预算该枚举值仅用作广告计划投放状态展示，不可在状态过滤时使用',
      AD_STATUS_CANNOT_EDIT: '不可编辑,该枚举值仅用作广告计划投放状态展示，不可在状态过滤时使用',
      AD_STATUS_EXTERNAL_URL_DISABLE: '落地页暂不可用，该枚举值仅用作广告计划投放状态展示,不可在状态过相时使用',
      AD_STATUS_LIVE_ROOM_OFF: '关联直播间末开播,该枚举值仅用作广告计划投放状态展示，不可在状态过滤时使用',
      AD_STATUS_AWEME_ACCOUNT_PUNISHED: '关联抖音账号封禁不可投放，该枚举值仅用作广告计划投放状态展示，不可在状态过滤时使用',
      AD_STATUS_AWEME_ACCOUNT_DISABLED: '关联抖音号不可投,该枚举值仅用作广告计划投放状态展示，不可在状态过滤时使用',
      AD_STATUS_PRODUCT_OFFUNE: '关联商品不可投，该枚举值仅用作广告计划投放状态展示,不可在状态过相时使用',
    };
    return dict[key];
  },
  // 计划投放范围
  deliveryRange: key => {
    const dict = {
      DEFAULT: '默认',
      UNION: '只投放到资讯联盟(穿山甲)',
      UNIVERSAL: '通投智选',
    };
    return dict[key];
  },
  // 计划出价类型
  adPricingType: key => {
    const dict = {
      PRICING_CPC: 'CPC',
      PRICING_CPM: 'CPM',
      PRICING_OCPC: 'OCPC',
      PRICING_OCPM: 'OCPM',
      PRICING_CPV: 'CPV',
      PRICING_CPA: 'CPA',
      PRICING_CPC_OCPM: 'CPC-OCPM',
    };
    return dict[key];
  },
  // 计划深度出价方式
  deepPriceType: key => {
    const dict = {
      DEEP_BID_DEFAULT: '不启用，无深度优化',
      DEEP_BID_PACING: '自动优化',
      DEEP_BID_MIN: '自定义双出价',
      SMARTBID: '自动优化',
      AUTO_MIN_SECOND_STAGE: '自定义双出价',
      ROI_COEFFICIENT: 'ROI系数',
      ROI_PACING: 'ROI系数——自动优化',
      MIN_SECOND_STAGE: '两阶段优化',
      PACING_SECOND_STAGE: '动态两阶段',
      BID_PER_ACTION: '每次付费出价',
    };
    return dict[key];
  },
  // 投放场景-竞价策略
  smartBidTypeFlowControlMode: key => {
    // 自动出价类型
    const dict1 = {
      SMART_BID_CUSTOM: '常规投放',
      SMART_BID_CONSERVATIVE: '放量投放',
    };
    // 计划投放速度类型
    const dict2 = {
      FLOW_CONTROL_MODE_FAST: '优先跑量(对应CPC的加速投放)',
      FLOW_CONTROL_MODE_SMOOTH: '优先低成本(对应CPC的标准投放)',
      FLOW_CONTROL_MODE_BALANCE: '均衡投放(新增字段)',
      FLOW_CONTROL_MODE_TWO_PHASES: '两阶段投放',
    };
    return (dict1[key.split(':')[0]] || '') + '-' + (dict2[key.split(':')[1]] || '');
  },
  // 计划详情地域
  district: key => {
    const dict = {
      CITY: '省市',
      COUNTY: '区县',
      BUSINESS_DISTRICT: '商圈',
      REGION: '行政区域',
      OVERSEA: '海外',
      NONE: '不限',
    };
    return dict[key];
  },
  // 计划详情广告位置
  inventoryCatalog: key => {
    const dict = {
      MANUAL: '首选媒体',
      SCENE: '场景广告位',
      SMART: '优选广告位',
      UNIVERSAL: '通投智选',
    };
    return dict[key];
  },
  // 计划详情应用商店直投
  downloadMode: key => {
    const dict = {
      APP_STORE_DELIVERY: '仅安卓应用下载支持',
      DEFAULT: '默认下载',
      APP_STORE_DELIVERY: '应用商店直投',
    };
    return dict[key];
  },
  // 计划详情转化目标
  convertType: key => {
    const dict = {
      AD_CONVERT_TYPE_EFFECTIVE_PLAY: '有效播放',
      AD_CONVERT_TYPE_CLICK_NUM: '点击量',
      AD_CONVERT_TYPE_SHOW_OFF_NUM: '展示量',
      AD_CONVERT_TYPE_PHONE: '电话拨打',
      AD_CONVERT_TYPE_FORM: '表单提交',
      AD_CONVERT_TYPE_MAP_SEARCH: '地图搜索',
      AD_CONVERT_TYPE_DOWNLOAD_FINISH: '下载完成',
      AD_CONVERT_TYPE_BUTTON: '按钮跳转',
      AD_CONVERT_TYPE_XPATH: 'xpath类型转换',
      AD_CONVERT_TYPE_VIEW: '关键页面浏览',
      AD_CONVERT_TYPE_ACTIVE: '激活',
      AD_CONVERT_TYPE_DOWNLOAD_START: '下载按钮download_start',
      AD_CONVERT_TYPE_QQ: 'qq咨询',
      AD_CONVERT_TYPE_LOTTERY: '抽奖',
      AD_CONVERT_TYPE_VOTE: '投票',
      AD_CONVERT_TYPE_ACTIVE_REGISTER: '激活且注册',
      AD_CONVERT_TYPE_PAY: '激活且付费',
      AD_CONVERT_TYPE_INSTALL_FINISH: '安装完成',
      AD_CONVERT_TYPE_PHONE_CONFIRM: '智能电话-确认拨打',
      AD_CONVERT_TYPE_PHONE_CONNECT: '智能电话-确认接通',
      AD_CONVERT_TYPE_PHONE_EFFECTIVE: '智能电话-有效接通',
      AD_CONVERT_TYPE_CONSULT_EFFECTIVE: '有效咨询',
      AD_CONVERT_TYPE_APP_ORDER: 'app内下单（电商）',
      AD_CONVERT_TYPE_APP_UV: 'app内访问',
      AD_CONVERT_TYPE_APP_CART: 'app内添加购物车（电商）',
      AD_CONVERT_TYPE_APP_PAY: 'app内付费',
      AD_CONVERT_TYPE_SALES_LEAD: '销售线索',
      AD_CONVERT_TYPE_GAME_ADDICTION: '关键行为（原深度转化）',
      AD_CONVERT_TYPE_CUSTOMER_EFFECTIVE: '有效获客',
      AD_CONVERT_TYPE_EFFECTIVE_COPY: '关键页面到达&有效内容复制',
      AD_CONVERT_TYPE_COUPON: '卡券领取',
      AD_CONVERT_TYPE_APP_DETAIL_UV: 'app内详情页到站uv',
      AD_CONVERT_TYPE_RSS: '账号关注',
      AD_CONVERT_TYPE_FORM_CONNECT: '表单提交-已接通',
      AD_CONVERT_TYPE_FORM_ANSWER: '有效沟通',
      AD_CONVERT_TYPE_DIALBACK: '提交回呼电话',
      AD_CONVERT_TYPE_DIALBACK_CONFIRM: '回呼电话-确认拨打',
      AD_CONVERT_TYPE_DIALBACK_CONNECT: '回呼电话-确认接通',
      AD_CONVERT_TYPE_FORM_DEEP: '分层表单',
      AD_CONVERT_TYPE_UPDATE_LEVEL: '激活且升级',
      AD_CONVERT_TYPE_CREATE_GAMEROLE: '激活且创建角色',
      AD_CONVERT_TYPE_NEXT_DAY_OPEN: '激活且次留',
      AD_CONVERT_TYPE_INVALID_CLUE: '无效线索',
      AD_CONVERT_TYPE_INTENTION_CLUE: '有意向客户',
      AD_CONVERT_TYPE_HIGH_VALUE_CLUE: '高价值客户',
      AD_CONVERT_TYPE_PAID_CLUE: '已成单',
      AD_CONVERT_TYPE_NATIVE_ACTION: '原生互动',
      AD_CONVERT_TYPE_LIKE_ACTION: '视频点赞',
      AD_CONVERT_TYPE_FOLLOW_ACTION: '账户关注',
      AD_CONVERT_TYPE_COMMENT_ACTION: '视频评论',
      AD_CONVERT_TYPE_LOCATION_ACTION: 'POI点击',
      AD_CONVERT_TYPE_SHOPPING_ACTION: '购物车点击',
      AD_CONVERT_TYPE_REDIRECT_TO_SHOP: '调起店铺',
      AD_CONVERT_TYPE_LINK_ACTION: 'link点击',
      AD_CONVERT_TYPE_DEEP_PURCHASE: '多次付费',
      AD_CONVERT_TYPE_SUCCESSORDER_ACTION: '小店转化',
      AD_CONVERT_TYPE_POI_COLLECT: 'poi地址点击',
      AD_CONVERT_TYPE_POI_ADDRESS_CLICK: 'poi收藏',
      AD_CONVERT_TYPE_RESERVATION: 'poi预定',
      AD_CONVERT_TYPE_MESSAGE_ACTION: '私信消息',
      AD_CONVERT_TYPE_SHARE_ACTION: '分享',
      AD_CONVERT_TYPE_CLICK_LANDING_PAGE: '访问推广详情页',
      AD_CONVERT_TYPE_CLICK_SHOPWINDOW: '访问主页商品橱窗',
      AD_CONVERT_TYPE_CLICK_DOWNLOAD: '访问主页下载应用',
      AD_CONVERT_TYPE_CLICK_CALL_DY: '点击主页内电话拨打',
      AD_CONVERT_TYPE_CLICK_WEBSITE: '访问主页官网',
      AD_CONVERT_PAGE_VIEW: '访问目标页面',
      AD_CONVERT_TYPE_MESSAGE: '短信',
      AD_CONVERT_TYPE_REDIRECT: '页面跳转',
      AD_CONVERT_TYPE_SHOPPING: '商品购买',
      AD_CONVERT_TYPE_CONSULT: '在线咨询',
      AD_CONVERT_TYPE_WECHAT: '微信',
      AD_CONVERT_TYPE_OTHER: '其他',
      AD_CONVERT_TYPE_MULTIPLE: '多转化事件',
      AD_CONVERT_TYPE_POI_MULTIPLE: 'POI门店多转化目标',
      AD_CONVERT_TYPE_INTERACTION: '互动',
      AD_CONVERT_TYPE_LOAN_COMPLETION: '互联网金融-完件',
      AD_CONVERT_TYPE_PRE_LOAN_CREDIT: '互联网金融-预授信',
      AD_CONVERT_TYPE_LOAN_CREDIT: '互联网金融-授信',
      AD_CONVERT_TYPE_IDCARD_INFORMATION: '身份证信息填写完成',
      AD_CONVERT_TYPE_BANKCARD_INFORMATION: '银行卡信息填写完成',
      AD_CONVERT_TYPE_PERSONAL_INFORMATION: '补充个人信息填写完成',
      AD_CONVERT_TYPE_CERTIFICATION_INFORMATION: '用户活体认证信息上传完成',
      AD_CONVERT_TYPE_LT_ROI: '广告变现ROI',
      AD_CONVERT_TYPE_LIVE_HOMEPAGE: '直播导流',
      AD_CONVERT_TYPE_REDIRECT_TO_STORE: '店铺导流',
      AD_CONVERT_TYPE_FEED_LIVE_HOMEPAGE: '火山feed进入直播页',
      AD_CONVERT_TYPE_AUTHORIZATION: '授权（电商）',
      AD_CONVERT_TYPE_COMMODITY_CLICK: '快上电商推广目的',
      AD_CONVERT_TYPE_CONSULT_CLUE: '留咨咨询',
      AD_CONVERT_TYPE_BOOST: '自然助推',
      AD_CONVERT_TYPE_STAY_TIME: '店铺停留',
      AD_CONVERT_TYPE_PURCHASE_OF_GOODS: '商品签收',
      AD_CONVERT_TYPE_PURCHASE_ROI: '付费ROI',
      AD_CONVERT_TYPE_LIVE_NATIVE_ACITON: '直播间原生互动',
      AD_CONVERT_TYPE_LIVE_FOLLOW_ACITON: '直播间关注',
      AD_CONVERT_TYPE_LIVE_COMMENT_ACTION: '直播间评论',
      AD_CONVERT_TYPE_LIVE_GIFT_ACTION: '直播间内打赏',
      AD_CONVERT_TYPE_LIVE_SLIDECART_CLICK_ACTION: '直播间查看购物车',
      AD_CONVERT_TYPE_LIVE_CLICK_PRODUCT_ACTION: '直播间查看商品',
      AD_CONVERT_TYPE_LIVE_ENTER_ACTION: '直播间观看',
      AD_CONVERT_TYPE_LIVE_SUCCESSORDER_ACTION: '直播间成单',
      AD_CONVERT_TYPE_NOTIFY_DOWNLOAD: '预约下载',
      AD_CONVERT_TYPE_PREMIUM_PAYMENT: '保险支付',
      AD_CONVERT_TYPE_MESSAGE_CLICK: '私信点击',
      AD_CONVERT_TYPE_UG_ROI: '内广roi',
      AD_CONVERT_TYPE_ENTER_HOMEPAGE: '进入个人主页',
      AD_CONVERT_TYPE_SHOPPING_CART: '商品购物车点击',
      AD_CONVERT_TYPE_WECHAT_REGISTER: '微信内注册',
      AD_CONVERT_TYPE_WECHAT_PAY: '微信内付费',
      AD_CONVERT_TYPE_MESSAGE_INTERACTION: '沟通互动',
      AD_CONVERT_TYPE_LIVE_STAY_TIME: '直播间停留',
      AD_CONVERT_TYPE_NEW_FOLLOW_ACTION: '粉丝增长',
      AD_CONVERT_TYPE_APPLET_CLICK: '小程序互动',
      AD_CONVERT_TYPE_MESSAGE_SERVICE: '私信服务',
      AD_CONVERT_TYPE_MESSAGE_CLUE: '私信留资',
      AD_CONVERT_TYPE_LIVE_FANS_ACTION: '直播间加入粉丝团',
      AD_CONVERT_TYPE_CLUE_CONFIRM: '回访_信息确认',
      AD_CONVERT_TYPE_CLUE_INTERFLOW: '回访_加为好友',
      AD_CONVERT_TYPE_CLUE_HIGH_INTENTION: '回访_高潜成交',
      AD_CONVERT_TYPE_SUBMIT_CERTIFICATION: '提交认证',
      AD_CONVERT_TYPE_FIRST_RENTAL_ORDER: '首次发单',
      AD_CONVERT_TYPE_LIVE_COMPONENT_CLICK: '组件点击',
      AD_CONVERT_TYPE_LIVE_BUSINESS_FITTING: '直播间组件点击',
      AD_CONVERT_TYPE_CLUE_PAY_SUCCEED: '支付_存在意向',
      AD_CONVERT_TYPE_OTO_STAY_TIME: '团单浏览',
      AD_CONVERT_TYPE_OTO_PAY: '团购支付',
      AD_CONVERT_TYPE_PREMIUM_ROI: '保费ROI',
      AD_CONVERT_TYPE_MESSAGE_ORDER_SUCCESS: '私信成单',
      AD_CONVERT_TYPE_MESSAGE_JOIN_GROUP: '私信用户入群',
      AD_CONVERT_TYPE_LIVE_JOIN_GROUP: '粉丝入群',
      AD_CONVERT_TYPE_LIVE_APPOINTMENT: '预约直播',
      AD_CONVERT_TYPE_FOLLOW_LIVE_ENTER: '粉丝访问直播',
      AD_CONVERT_TYPE_FOLLOW_CLICK_PRODUCT: '关注并加购',
      AD_CONVERT_TYPE_FOLLOW_VIDEO_PLAY_FINISH: '粉丝观看',
      AD_CONVERT_TYPE_GAMESTATION_DOWNLOAD_DOUPLUS: '游戏站下载 - DOU +',
      AD_CONVERT_TYPE_QC_FOLLOW_ACTION: '提升粉丝',
      AD_CONVERT_TYPE_QC_MUST_BUY: '内容种草',
      AD_CONVERT_TYPE_NOTIFY_FORM: '预约表单',
      AD_CONVERT_TYPE_IPU_QUALIFY: '激活首日广告展示达标',
      AD_CONVERT_TYPE_ANCHOR_CLICK: '直播支付ROI',
      AD_CONVERT_TYPE_PURCHASE_ROI_2D: '付费roi-2日',
      AD_CONVERT_TYPE_PURCHASE_ROI_7D: '付费roi-7日',
    };
    return dict[key];
  },
  // 计划详情受众平台类型
  platForm: key => {
    const dict = {
      ANDROID: 'android',
      I0S: 'iOs',
      PC: 'PC',
      IPAD: 'ipad',
      WAP: 'wap',
    };
    let arr = [];
    if (Array.isArray(key)) {
      key.forEach(item => {
        arr.push(dict[item]);
      });
      return arr.join(',');
    }
    return dict[key];
  },
  // 计划详情年龄
  age: key => {
    const dict = {
      AGE_BETWEEN_18_23: '18-23岁',
      AGE_BETWEEN_24_30: '24-30岁',
      AGE_BETWEEN_31_40: '31-40岁',
      AGE_BETWEEN_41_49: '41-49岁.',
      AGE_ABOVE_50: '大于等于50岁',
    };
    let arr = [];
    if (Array.isArray(key)) {
      key.forEach(item => {
        arr.push(dict[item]);
      });
      return arr.join(',');
    }
    return dict[key];
  },
};
// 磁力引擎
export const clyqDict = {
  // 广告投放位置
  sceneId: key => {
    const dict = {
      1: '优选广告位',
      5: '联盟广告',
      6: '上下滑大屏广告',
      7: '信息流广告',
      10: '联盟场景',
      11: '快看点场景',
      24: '激励视频',
      27: '开屏广告位',
    };
    return dict[key];
  },
  // 创意状态
  creativityStatus: key => {
    const dict = {
      [-1]: '不限',
      1: '计划已暂停',
      3: '计划超预算',
      6: '余额不足',
      11: '组审核中',
      12: '组审核未通过',
      14: '已结束',
      15: '组已暂停',
      17: '组超预算',
      19: '未达投放时间',
      22: '不在投放时段',
      41: '审核中',
      42: '审核未通过',
      46: '已暂停',
      52: '投放中',
      53: '作品异常 ',
      [-2]: '所有包含已删除',
      40: '只包含已删除不传',
    };
    return dict[key];
  },
  // 推广目的类型
  landingType: key => {
    const dict = {
      LINK: '销售线索收集',
      APP: '应用推广',
      QUICK_APP: '快应用推广',
      DPA: '商品目录推广',
      G0ODS: '商品推广(鲁班)',
      STORE: '门店推广',
      AWEME: '抖音号推广',
      SHOP: '电商店铺推广',
      LIVE: '直播间推广',
      ARTICAL: '头条文章推广。目前API暂不支持该推广目的的设定,可在平台侧选择该推广目的类型',
    };
    return dict[key];
  },
  // 广告组状态
  adStatus: key => {
    const dict = {
      [-1]: '不限',
      1: '计划已暂停',
      3: '计划超预算',
      6: '余额不足',
      10: '只包含已删除不传:所有不包含已删除 其他值无效',
      11: '审核中',
      12: '审核未通过',
      14: '已结束',
      15: '已暂停',
      17: '组超预算',
      19: '未达投放时间',
      20: '有效',
      22: '不在投放时段,所有包含已删除',
    };
    return dict[parseInt(key)];
  },
  // 计划状态
  campaignStatus: key => {
    const dict = {
      1: '已暂停',
      3: '超预算',
      4: '投放中',
      5: '已删除',
    };
    return dict[key];
  },
  // 计划营销目标
  campaignTarget: key => {
    const dict = {
      2: '提升应用安装',
      3: '获取电商下单',
      4: '推广品牌活动',
      5: '收集销售线索',
      7: '提高应用活跃',
      9: '商品库推广',
    };
    return dict[key];
  },
  // 出价类型
  bidType: key => {
    const dict = { 1: 'CPM', 2: 'CPC', 6: 'OCPC', 10: 'OCPM', 20: 'eCPC' };
    return dict[key];
  },
  // 广告组预算
  budgetType: key => {
    const flag = key.split(':')[1];
    if (flag == 'BUDGET_MODE_INFINITE') {
      return '不限';
    } else {
      return key.split(':')[0] ? key.split(':')[0] + ' 元/天' : '-';
    }
  },
  // 计划首选位置
  inventoryType: key => {
    const adInventoryType = localStorage.adInventoryTypeCodesOptionsKS && JSON.parse(localStorage.adInventoryTypeCodesOptionsKS);
    let dict = {};
    adInventoryType?.forEach(item => {
      dict[item.value] = item.label;
    });
    dict =
      adInventoryType.length > 0
        ? dict
        : {
            INVENTORY_AUTOMOBILE: '懂车帝',
            INVENTORY_AWEME_FEED: '抖音信息',
            INVENTORY_AWEME_SEARCH: '搜索广告——抖音位',
            INVENTORY_BEAUTY: '轻颜相机',
            INVENTORY_FACE_U: 'faceu',
            INVENTORY_FEED: '头条信息流',
            INVENTORY_HOTSOON_FEED: '火山信息流',
            INVENTORY_PIPIXIA: '皮皮虾',
            INVENTORY_SEARCH: '搜索广告——头条位',
            INVENTORY_STUDY: '好好学习',
            INVENTORY_TEXT_LINK: '头条文章详情页',
            INVENTORY_TOMATO_NOVEL: '番茄小说',
            INVENTORY_UNION_SLOT: '穿山甲',
            INVENTORY_UNION_SPLASH_SLOT: '穿山甲开屏广告',
            INVENTORY_UNIVERSAL: '通投智选',
            INVENTORY_VIDEO_FEED: '西瓜信息流',
            UNION_BOUTIQUE_GAME: 'ohayoo精品游戏',
          };
    return dict[key];
  },
  // 广告组详情url链接类型
  urlType: key => {
    const dict = {
      '1': '淘宝商品短链',
      '2': '淘宝商品 itemID',
      '4': '金牛电商',
    };
    return dict[key];
  },
  // 广告组详情创意展现方式
  showMode: key => {
    const dict = { '0': '未知', '1': '轮播', '2': '优选' };
    return dict[key];
  },
  // 广告组详情投放方式
  speed: key => {
    const dict = { 0: '未知', 1: '正常投放', 2: '平滑投放', 3: '优先低成本' };
    return dict[key];
  },
  // 广告组详情优化目标
  ocpxActionType: key => {
    const dict = { 0: '未知', 2: '点击转化链接', 10: '曝光', 11: '点击', 31: '下载完成', 53: '提交线索', 109: '电话卡激活', 137: '量房', 180: '激活', 190: '付费', 191: '首日 ROI', 348: '有效线索', 383: '授信', 384: '完件', 715: '微信复制', 739: '7日付费次数' };
    return dict[key];
  },
  // 广告组详情深度转化目标
  deepConversionType: key => {
    const dict = { 3: '付费', 7: '次日留存', 10: '完件', 11: '授信', 0: '无' };
    return dict[key];
  },
};
